import React from 'react'
import { useSearch } from '../../context/search.js'
import axios from 'axios' 
import { useNavigate } from "react-router-dom";
import "../SearchInput/SearchInput.css"
const SearchInput = () => {
    const [values,setValues]=useSearch()
    const navigate = useNavigate();


    const handleSubmit = async (e) => {
        e.preventDefault();
      
        try {
          const {data} = await axios.get(`/api/v1/product/search/${values.keyword}`)
        
        setValues({...values,results: data});
        navigate("/search");
      }
        catch (error) {
          console.log(error); 
        }
      };
      
      
      
  return (
    <div>
      <form
        className="d-flex search-form SearchMAINDIV"
        role="search"
        onSubmit={handleSubmit}
      >
        <input
          className="form-control me-2 searchBoxPRODUCT"
          type="search"
          placeholder="Search"
          aria-label="Search"
          value={values.keyword}
          onChange={(e) => setValues({ ...values, keyword: e.target.value })}
        />
        <button className="btn btn-outline-success" type="submit">
          Search
        </button>
      </form>
    </div>
  )
}

export default SearchInput;
